.root {
  border-radius: 20px;
  padding: 8px !important;
  cursor: pointer;
  border: 1px solid transparent !important;
  transition:
    transform 250ms ease,
    background-color 250ms ease,
    border 250ms ease;

  @media (max-width: 768px) {
    padding: 5px 12px;

    .description {
      display: none;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .label,
  .description,
  .icon {
    transition: color 250ms ease;
    color: rgba(255, 255, 255, 0.85);
  }

  &:not([data-active='true']) {
    background-color: transparent;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.3) !important;
      transform: translateY(2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

      .label,
      .description,
      .icon {
        color: white;
      }
    }
  }

  &[data-active='true'] {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.4) !important;

    .label,
    .description,
    .icon {
      color: #fff;
    }

    &:hover .icon {
      color: #ffd8e4;
    }
  }
}
